export default __webpack_public_path__ + "static/media/notification.ee18cb82.mp3";